module.exports = __webpack_public_path__ + "static/media/red-dress.db024a03.jpg";